// extracted by mini-css-extract-plugin
export default {"circle":"trafficLight_circle__YIpdR"};